import Vue from 'vue'
import Vuex from 'vuex'

import confirmations from './modules/confirmations'
import users from './modules/users'
import sessions from './modules/sessions'
import projects from './modules/projects'
import articles from './modules/articles'
import crafts from './modules/crafts'
import purchases from './modules/purchases'
import comments from './modules/comments'
import stores from './modules/stores'
import recoveries from './modules/recoveries'
import search from './modules/search'
import craftPurchaseCategories from './modules/craft_purchase_categories'
import questionAnswers from './modules/question_answers'
import contacts from './modules/contacts'
import publications from './modules/publications'
import collectionItems from './modules/collection_items'
import skills from '@/store/modules/skills'
import themes from '@/store/modules/themes'
import images from '@/store/modules/images'
import articleTopics from '@/store/modules/article_topics'
import steps from '@/store/modules/steps'
import notifications from '@/store/modules/notifications'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: null,
    token: localStorage.getItem('token') || null
  },
  getters: {
    currentUser: state => state.user,
    isLoggedIn: state => !!state.token,
    isOwner: (state, getters) => userId => {
      return getters.currentUser && userId === state.user.attributes.id
    }
  },
  actions: {
    setup: ({ commit, dispatch, rootState }, { user, token }) => {
      commit('authenticate', { user, token })
      commit('initActionCable', token)
      dispatch('notifications/index', 1)
    }
  },
  mutations: {
    authenticate (state, { user, token }) {
      state.user = user
      state.token = token
    },
    initActionCable (state, token) {
      this.$cable._connectionUrl = `${process.env.VUE_APP_COSTUTO_BACKEND_WS_HOST}/cable?token=${token}`
      this.$cable.subscribe({
        channel: 'UserChannel'
      })
    },
    updateUser (state, user) {
      state.user = user
    },
    logout (state) {
      state.user = null
      state.token = null
    }
  },
  modules: {
    articles,
    users,
    sessions,
    confirmations,
    projects,
    crafts,
    purchases,
    comments,
    recoveries,
    craftPurchaseCategories,
    search,
    contacts,
    questionAnswers,
    publications,
    collectionItems,
    stores,
    skills,
    themes,
    images,
    articleTopics,
    steps,
    notifications
  }
})
